<div mat-dialog-content class="material-admin-colors">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <ng-container *ngIf="!isPendingLicenseActivation">
      <p class="text-center">Install a new license from activation key
        <a target="_blank" href="https://monitorsanywhere.com/how-to-activate-monitors-anywhere-license/">?</a>
      </p>

      <mat-form-field class="w-100">
        <mat-label>Activation Key</mat-label>
        <input matInput type="text" required placeholder="Activation Key" formControlName="licenseKey"
          (blur)="onBlur($event)">
        <mat-error *ngIf="licenseKey?.errors?.required">Field is required</mat-error>
        <mat-error *ngIf="licenseKey?.errors?.invalidKey">Invalid license key</mat-error>
      </mat-form-field>

      <button class="btn w-100 colored mt-1" mat-raised-button type="submit" [disabled]="form.invalid">
        Activate
      </button>
    </ng-container>


    <div class="d-flex justify-content-center" *ngIf="isPendingLicenseActivation">
      <app-loader></app-loader>
    </div>
  </form>

  <div class="mt-5">
    <p class="text-center">If this MAWi Server is not currently connected to the Internet, please generate a license
      request and send it with your activation key to:
      <a href="mailto:licenses@monitorsanywhere.com">licenses&#64;monitorsanywhere.com</a>
    </p>

    <button class="btn w-100 mt-1" mat-raised-button type="submit" (click)="openGenerateLicenseDialog()">
      Generate license request
    </button>
  </div>

  <div class="mt-5 pb-2">
    <p class="text-center">Upload the license file you`ve received from our licensing department</p>

    <button class="btn w-100 colored px-0 p-0 mt-1" mat-raised-button type="button" *ngIf="!uploadedFile">
      <label class="upload-button mb-0 w-100" (click)="form.reset()">
        <input type="file" (change)="newFileUpload($event.target.files[0])" class="d-none" accept=".olic,.lic">
        Browse license file
      </label>
    </button>

    <button class="btn w-100 colored px-0 p-0 mt-1" mat-raised-button type="button" *ngIf="uploadedFile"
      (click)="newFileUploaded()">
      <label class="upload-button mb-0 w-100">
        Upload <i>{{uploadedFile?.name}}</i> license file
      </label>

      <span class="delete-file" (click)="uploadedFile = nulll"
        [matTooltip]="'Delete ' + uploadedFile.name">&times;</span>
    </button>
  </div>

  <mat-icon class="close-button" (click)="onClose()" svgIcon="close" matTooltip="Close"></mat-icon>
</div>